import React from 'react';

const SponsorSection = () => {
  return (
    <section className="sponsor-section">
      <div className="container">
        <h2 className="sponsor-title">함께하는 기업</h2>
        <div className="sponsor-logos">
          <a
            href="http://earthlingsave.co.kr/"
            target="_blank"
            rel="noopener noreferrer"
            className="sponsor-logo-link"
          >
            <img
              src="/earthsaving.png"
              alt="Earth Saving"
              className="sponsor-logo-image"
            />
          </a>
          <a
            href="https://thevega.com"
            target="_blank"
            rel="noopener noreferrer"
            className="sponsor-logo-link"
          >
            <img
              src="/thevega.png"
              alt="The Vega"
              className="sponsor-logo-image"
            />
          </a>
          <a
            href="https://tvcf.co.kr"
            target="_blank"
            rel="noopener noreferrer"
            className="sponsor-logo-link"
          >
            <img
              src="/tvcf.png"
              alt="TVCF"
              className="sponsor-logo-image"
            />
          </a>
        </div>
      </div>
    </section>
  );
};

export default SponsorSection;

